import { SvgProps } from "../../types";

const Correction = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={13}
    fill="none"
    {...props}>
    <path
      fill={props.fill}
      d="M1.522 12.5c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.392-.941V1.833c0-.366.131-.68.392-.941C.841.63 1.155.5 1.522.5h10.666c.367 0 .681.13.942.392.261.26.392.575.392.941v9.334c0 .366-.13.68-.392.941a1.284 1.284 0 0 1-.942.392H1.522Zm0-1.333h10.666V1.833H1.522v9.334Zm.666-1.334h3.334V8.5H2.188v1.333ZM8.555 8.5l3.3-3.3-.95-.95-2.35 2.367-.95-.95-.933.95L8.555 8.5ZM2.188 7.167h3.334V5.833H2.188v1.334Zm0-2.667h3.334V3.167H2.188V4.5Z"
    />
  </svg>
);
export default Correction;
